module.exports = __webpack_public_path__ + "img/tdb-thermicien.b4f3340d.jpg";